import { render, staticRenderFns } from "./IssuePage.vue?vue&type=template&id=b37f87aa&scoped=true&"
import script from "./IssuePage.vue?vue&type=script&lang=js&"
export * from "./IssuePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b37f87aa",
  null
  
)

export default component.exports